export const auth = process.env.REACT_APP_AUTH_URL as string
export const member = process.env.REACT_APP_MEMBER_URL as string
export const provider = process.env.REACT_APP_PROVIDER_URL as string
